/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

export const legalRegulatoryEnumsLegalOrRegulatoryObligationPotentiallyBreachedOptionEnum = {
    Yes: 'Yes',
    No: 'No',
    NotSure: 'NotSure',
} as const;

export type LegalRegulatoryEnumsLegalOrRegulatoryObligationPotentiallyBreachedOptionEnumKey =
    (typeof legalRegulatoryEnumsLegalOrRegulatoryObligationPotentiallyBreachedOptionEnum)[keyof typeof legalRegulatoryEnumsLegalOrRegulatoryObligationPotentiallyBreachedOptionEnum];

export type LegalRegulatoryEnumsLegalOrRegulatoryObligationPotentiallyBreachedOption =
    LegalRegulatoryEnumsLegalOrRegulatoryObligationPotentiallyBreachedOptionEnumKey;
